import { Component, Input, OnInit, Output, EventEmitter, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UIIconsComponent } from 'src/app/shared/ui/icons/icons.component';
import { PostHogService } from 'src/app/shared/services/post-hog.service';
import { ExportService } from '../../services/export.service';

@Component({
  selector: 'app-export-data',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    UIIconsComponent
  ],
  templateUrl: './export-data.component.html',
  styleUrls: ['./export-data.component.css']
})
export class ExportDataComponent implements OnInit {
  private postHogService = inject(PostHogService);
  private exportService = inject(ExportService);

  @Input() defaultFileName: string = 'exported_data';
  @Input() reportVisualType: string = 'TABLE';
  @Input() showHeader: boolean = true;
  @Input() modalTitle: string = 'Share and export';
  @Input() axisAttributesAndMeasures: any;
  @Input() hasChartData: boolean = false;

  @Output() switchToChartView = new EventEmitter<void>();

  public exportFileName: string = '';
  public exportType: 'TABLE' | 'CHART' | 'BOTH' = 'TABLE';
  public selectedFormat: string = '';

  public gridFileTypes: any[] = [
    { icon: 'file-text', label: 'PDF' },
    { icon: 'file-digit', label: 'XLSX' },
    { icon: 'file-digit', label: 'XLS' },
    { icon: 'file-spreadsheet', label: 'CSV' },
  ];
  
  public chartFileTypes: any[] = [
    { icon: 'file-text', label: 'PDF' },
    { icon: 'file-image', label: 'JPG' },
    { icon: 'file-image', label: 'PNG' }
  ];

  public bothFileTypes: any[] = [
    { icon: 'file-text', label: 'PDF' },
    { icon: 'file-image', label: 'JPG' },
    { icon: 'file-image', label: 'PNG' }
  ];

  ngOnInit(): void {
    this.exportFileName = this.defaultFileName;
    this.exportType = this.reportVisualType === 'CHART' ? 'CHART' : 'TABLE';
  }

  public get canExport(): boolean {
    return !!this.exportFileName && !!this.selectedFormat;
  }

  public get isChartDataValid(): boolean {
    return this.hasChartData || !!(this.axisAttributesAndMeasures?.xAxis && this.axisAttributesAndMeasures?.yAxis);
  }

  public get chartDisabledMessage(): string {
    if (!this.isChartDataValid) {
      return 'Chart data not available for export';
    }
    return '';
  }
  
  public setExportType(type: 'TABLE' | 'CHART' | 'BOTH'): void {
    if ((type === 'CHART' || type === 'BOTH') && this.reportVisualType === 'TABLE') {
      this.switchToChartView.emit();
    }

    this.exportType = type;
    this.selectedFormat = '';
    this.exportService.$reportExportFormatTypeChange.next(type === 'BOTH' ? 'CHART' : type);
  }
  
  public selectFormat(format: string): void {
    this.selectedFormat = format;
  }
  
  public handleExport(): void {
    if (!this.canExport) return;
    
    this.postHogService.capture(`EXPORT DATA: EXPORT TO ${this.selectedFormat}`);
    this.exportService.exportDataToFormat(
      this.selectedFormat, 
      this.exportFileName, 
      this.exportType
    );
  }
}